/*
  FluoFree — scrollspy voor ff-sectienav.

  De links werken zonder dit bestand: het zijn gewone ankerlinks en de browser
  springt er zelf naartoe. Dit script voegt alleen één ding toe — markeren welke
  sectie je nu leest — en raakt de navigatie verder niet aan.

  Bij prefers-reduced-motion blijft het markeren werken, maar schuift de balk de
  actieve link niet meer in beeld: dat is een beweging die de bezoeker niet heeft
  gevraagd.
*/
(function () {
  'use strict';

  function start(root) {
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-ff-nav-link]'));
    if (!links.length || !window.IntersectionObserver) return;

    var spoor = root.querySelector('[data-ff-nav-track]');
    var rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Alleen ankers die echt op de pagina staan. Een link naar een sectie die
       op dit sjabloon niet bestaat blijft gewoon klikbaar, maar doet niet mee
       aan het markeren. */
    var paren = [];
    links.forEach(function (link) {
      var id = link.getAttribute('data-ff-nav-link');
      var doel = id && document.getElementById(id);
      if (doel) paren.push({ link: link, doel: doel, id: id, ratio: 0 });
    });
    if (!paren.length) return;

    var actief = '';

    function markeer() {
      var beste = null;
      paren.forEach(function (paar) {
        if (!beste || paar.ratio > beste.ratio) beste = paar;
      });
      if (!beste || beste.ratio === 0 || beste.id === actief) return;
      actief = beste.id;
      paren.forEach(function (paar) {
        if (paar.id === actief) {
          paar.link.setAttribute('aria-current', 'true');
        } else {
          paar.link.removeAttribute('aria-current');
        }
      });
      if (spoor && !rustig) {
        /* Houd de actieve link zichtbaar op smalle schermen, waar de balk
           horizontaal schuift. */
        var l = beste.link;
        var doelLinks = l.offsetLeft - (spoor.clientWidth - l.offsetWidth) / 2;
        if (spoor.scrollTo) {
          spoor.scrollTo({ left: doelLinks, behavior: 'smooth' });
        } else {
          spoor.scrollLeft = doelLinks;
        }
      }
    }

    var waarnemer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        for (var i = 0; i < paren.length; i++) {
          if (paren[i].doel === entry.target) {
            paren[i].ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
            break;
          }
        }
      });
      markeer();
    }, { threshold: [0, 0.15, 0.4, 0.75], rootMargin: '-80px 0px -45% 0px' });

    paren.forEach(function (paar) { waarnemer.observe(paar.doel); });
  }

  function alles() {
    Array.prototype.slice.call(document.querySelectorAll('[data-ff-sectienav]')).forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alles);
  } else {
    alles();
  }
  document.addEventListener('shopify:section:load', alles);
})();
